// imports
import { Address } from 'abitype';
import { readContract } from '../wagmi';
import { IContractProps } from '../wagmi/types';
import ArbNova from '../abi/arbitrum_nova.json';
import ArbGeorli from '../abi/arbitrum_goerli.json';

// interfaces / types / consts
const L2Chain = (process.env.REACT_APP_ENVIRONMENT === 'prod' || process.env.REACT_APP_ENVIRONMENT === 'stage') ? ArbNova : ArbGeorli;
const WL_FORWARDER = L2Chain.contracts.ERC2771Forwarder as IContractProps;

// exports - meta
export const CONTRACT_ADDRESS = WL_FORWARDER.address!;

// exports - views
export function nonces(address: Address): Promise<string> {
  return readContract({
    args: [address],
    abi: WL_FORWARDER.abi,
    functionName: 'nonces',
    address: WL_FORWARDER.address,
    chainId: Number(L2Chain.chainId)
  }).then((data) => (data as string).toString());
}

export function verify(request: unknown): Promise<boolean> {
  return readContract({
    args: [request],
    abi: WL_FORWARDER.abi,
    functionName: 'verify',
    address: WL_FORWARDER.address,
    chainId: Number(L2Chain.chainId)
  }).then((data) => data as boolean);
}

// exports - default
export default { CONTRACT_ADDRESS, nonces, verify };
